import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Radios from './Radios';
import Profiles from './Profiles';

import { close, listupdater, loadingflas, open } from '../redux/popupSlice';
import * as APIS from "../utils/service";
import { getMemberinfo, hpHypen, numFormat } from '../utils/utils';
import Checkbox from './Checkbox';
import PopProductLeftDetail from './PopProductLeftDetail';


export default function ProductTogetherSendPop(props) {

    const {
        setproductdetailflag = () => { },
        setbellshowflag = () => { },
        setproducttogethersendflag = () => { },
        productIdx = ''
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { configdata } = useSelector(s => s.configReducer);
    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return { names: x?.title, values: x?.idx }
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return { names: x?.title, values: x?.idx, category_1: x?.category_1 }
    })
    const [nolistflag, setnolistflag] = useState(false);
    const [radio1, setradio1] = useState(0);
    const [checkvalues, setcheckvalues] = useState([]);

    const [row, setrow] = useState({});
    const [customer, setcustomer] = useState({});
    const [mediation, setmediation] = useState({});
    const [errormsg, seterrormsg] = useState('');
    const [detaildata, setdetaildata] = useState({});
    const [productdetailPop, setproductdetailPop] = useState(false);


    const [detailinfos, setdetailinfos] = useState([
        { viewernames: '보증금', values: '5,000만원' },
        { viewernames: '월세', values: '200만원' },
        { viewernames: '관리비', values: '30만원' },
        { viewernames: '권리금', values: '5,000만원' },
        { viewernames: '실투자금', values: '10,000만원' },
        { viewernames: '매물종류', values: '상가' },
        { viewernames: '건물명', values: '골든프라자' },
        { viewernames: '해당동 총 층', values: '4층' },
        { viewernames: '층 수', values: '1층' },
        { viewernames: '계약면적', values: '100,95㎡(약 30평)' },
        { viewernames: '전용면적', values: '73,87㎡(22평)' },
        { viewernames: '방향기준/방향', values: '북/주된출입구' },
        { viewernames: '건축물용도', values: '제2종근린생활시설' },
        { viewernames: '건축물일자', values: '사용승인 20090908' },
        { viewernames: '입주가능일', values: '협의' },
    ]);

    const [checkcommentArr, setcheckcommentArr] = useState([
        { numbers: '1.', comment: '상대 중개사가 요청을 수락하면 상대 중개사에게 의뢰인 연락처·특이사항 외 모든 정보가 전달 됩니다.' },
        { numbers: '2.', comment: '공동중개 요청·승낙 시 계약 유무와 별개로 상호간 공동중개 경험을 \'친절함·전문성·협조성\'을 점수로 평가 할 수 있으며 이는 타 중개사가 공동중개를 요청하기 전 점수를 확인할 수 있습니다. (공동중개 진행 여부에 영향을 미칠 수 있음.)' },
        { numbers: '3.', comment: '동일 부동산과의 공동중개가 여러번 진행되어도 평가는 최고점 1개만 적용 되며, 입력 된 평가는 특별한 사유 없이는 작성자 본인 외 수정·삭제가 불가능합니다.' },
        { numbers: '4.', comment: '평가 점수를 조작하기 위한 의도적인 작업이 적발되는 경우 내부 규정에 의거 공동중개 이용에 제한이 생길 수 있습니다.' },
        { numbers: '5.', comment: '악의적인 평가임이 확인되는 경우 별도 문의주시면 내부 규정에 맞는 서류 등을 안내 해드리며, 운영 규정에 따라 해당 평가는 삭제되며 악의적 작성자에게는 이용 제한 등의 불이익이 발생할 수 있습니다.' },
        { numbers: '6.', comment: '후기는 가입 시 입력된 ‘자격증 번호’ 등 ‘개인’에게 영구 저장되므로 이직·신규 개설·이전 개설을 진행하더라도 ‘자격증 번호’에 따른 점수가 노출됩니다.' },
        { numbers: '7.', comment: '따라서, 공동중개를 진행하시면 반드시 상도덕을 지키고 매너있는 협업을 진행해주시기 바랍니다.\n＊ 5건 미만의 경우 점수 등이 노출되지 않습니다' },
    ]);

    const [matchinglist, setmatchinglist] = useState([
        { buildingnumber: '88700', dates: '23.05.05', buildingtype: '상가', buildingpricetype: '월세', taglist: '삽결살 마포, 은형', priceData: '월세 2,000/200', addrtxt: '마포구 전체, 은평구 전체' },
        { buildingnumber: '88700', dates: '23.05.05', buildingtype: '상가', buildingpricetype: '월세', taglist: '삽결살 마포, 은형', priceData: '월세 2,000/200', addrtxt: '마포구 전체, 은평구 전체' },
    ]);

    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);
    useEffect(() => {
        rowDataSubmit();
    }, [productIdx]);

    const rowDataSubmit = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = { idx: productIdx }
        console.log(sender);
        APIS.postData('/v1/mediation/get', sender).then(({ data }) => {
            if (data) {
                const { item, customer, mediation } = data;

                console.log("??????????????", data);
                setrow(item);
                setcustomer(customer);
                setmediation(mediation);

                let productinfo = {};

                if (mediation?.type * 1 === 1) {
                    productinfo = customer;
                    setdetailinfos([
                        { viewernames: '고객번호', values: productinfo?.idx },
                        { viewernames: productinfo?.sell_type === '매매' ? '희망 매매가' : '희망 보증금', values: `${numFormat(productinfo?.price_all_min)}만원 ~ ${numFormat(productinfo?.price_all_max)}만원` },
                        { viewernames: '희망 월세', values: `${numFormat(productinfo?.price_month_min)}만원 ~ ${numFormat(productinfo?.price_month_max)}만원` },
                        //{viewernames: '권리금', values: `${numFormat(productinfo?.price_key_min)}만원 ~ ${numFormat(productinfo?.price_key_min)}만원`},
                        //{viewernames: '실투자금', values: `${numFormat(productinfo?.price_real)}만원`},
                        { viewernames: '희망 매물종류', values: category_2_setting?.find(x => x?.values * 1 === productinfo?.category_2 * 1)?.names },
                        { viewernames: '희망 층수', values: `${numFormat(productinfo?.item_floor_min)}층 ~ ${numFormat(productinfo?.item_floor_max)}층` },
                        { viewernames: '희망 면적', values: `${numFormat(productinfo?.item_area_min)}㎡ ~ ${numFormat(productinfo?.item_area_max)}㎡` },
                        { viewernames: '희망 연식', values: `${productinfo?.item_year_min}년 ~ ${productinfo?.item_year_max}년` },
                        { viewernames: '입주시기', values: `${productinfo?.in_year} ${productinfo?.in_year_option1 ? '협의가능' : ''}  ${productinfo?.in_year_option2 ? '상관없음' : ''}` },
                    ]);

                } else {
                    productinfo = item;

                    setdetailinfos([
                        { viewernames: '매물번호', values: productinfo?.idx },
                        { viewernames: '주소', values: `${productinfo?.sido} ${productinfo?.sigungu} ${productinfo?.dong}` },
                        { viewernames: '매물종류', values: category_2_setting?.find(x => x?.values * 1 === productinfo?.category_2 * 1)?.names },
                        // {viewernames: '건물명', values: productinfo?.title},
                        // {viewernames: '해당동 총 층', values: String(productinfo?.building_dong_floor_all).replace("층","")+'층'},
                        // {viewernames: '층 수', values: String(productinfo?.building_floor).replace("층","")+'층'},
                        (productinfo?.category_1*1 === 1 || productinfo?.category_1*1 === 2) && {viewernames: '해당층', values: String(productinfo?.building_floor).replace("층","")+'층'},
                        // {viewernames: (productinfo?.category_2*1 === 9 || productinfo?.category_2*1 === 10 || productinfo?.category_2*1 === 11) ? '연면적' : '전용면적', values: `${productinfo?.area_private}㎡ (약 ${((productinfo?.area_private*1)/3.3057).toFixed(2)}평)`},
                        (productinfo?.category_1*1 === 1 || productinfo?.category_1*1 === 2) && { viewernames: '전용면적', values: `${productinfo?.area_private}㎡ (약 ${((productinfo?.area_private * 1) / 3.3057).toFixed(2)}평)` },
                        (productinfo?.category_1*1 === 3) && { viewernames: '토지면적', values: `${productinfo?.area_land}㎡ (약 ${((productinfo?.area_land * 1) / 3.3057).toFixed(2)}평)` },
                        (productinfo?.category_1*1 === 3) && { viewernames: '연면적', values: `${productinfo?.area_floor * 1}㎡ (약 ${((productinfo?.area_floor * 1) / 3.3057).toFixed(2)}평)` },
                        (productinfo?.category_1*1 === 3) && {viewernames: '지하총층', values: String(productinfo?.building_floor_under_all).replace("층","")+'층'},
                        (productinfo?.category_1*1 === 3) && {viewernames: '지상총층', values: String(productinfo?.building_floor_all).replace("층","")+'층'},
                        { viewernames: '방향기준/방향', values: `${productinfo?.item_direction_standard}/${productinfo?.item_direction}` },
                        { viewernames: '건축물용도', values: productinfo?.item_usage },
                        { viewernames: '건축물일자', values: `${productinfo?.item_date_type}/${productinfo?.item_date}` },
                        { viewernames: '입주가능일', values: productinfo?.item_move_date + (productinfo?.item_move_type ? `, ${productinfo?.item_move_type}` : "") },
                    ]);
                }

                // setdetailinfos([
                //     {viewernames: '매매가', values: numFormat(item?.price_sell)+'만원'},
                //     {viewernames: '보증금', values: numFormat(item?.price_all)+'만원'},
                //     {viewernames: '월세', values: numFormat(item?.price_month)+'만원'},
                //     {viewernames: '관리비', values: numFormat(item?.price_maintenance)+'만원'},
                //     item?.price_keymoney && {viewernames: '권리금', values: numFormat(item?.price_keymoney)+'만원'},
                //     {viewernames: '매물종류', values: category_1_setting?.find(x => x?.values*1 === item?.category_1*1)?.names},
                //     {viewernames: '건물명', values: item?.title},
                //     {viewernames: '해당동 총 층', values: item?.building_dong_floor_all+'층'},
                //     {viewernames: '층 수', values: item?.building_floor+'층'},
                //     item?.area_contract && {viewernames: '계약면적', values: `${item?.area_contract}㎡ (약 ${((item?.area_contract*1)/3.3057).toFixed(2)}평)`},
                //     item?.area_land && {viewernames: '토지면적', values: `${item?.area_land}㎡ (약 ${((item?.area_land*1)/3.3057).toFixed(2)}평)`},
                //     {viewernames: '공급면적', values: `${item?.area_supply}㎡ (약 ${((item?.area_supply*1)/3.3057).toFixed(2)}평)`},
                //     {viewernames: '전용면적', values: `${item?.area_private}㎡ (약 ${((item?.area_private*1)/3.3057).toFixed(2)}평)`},
                //     {viewernames: '방향기준/방향', values: `${item?.item_direction_standard}/${item?.item_direction}`},
                //     {viewernames: '건축물용도', values: item?.item_usage},
                //     {viewernames: '건축물일자', values: `${item?.item_date_type}/${item?.item_date}`},
                //     {viewernames: '입주가능일', values: item?.item_move_date},
                // ]); 
                //console.log(item?.my_arr);
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }
    /*
    매물확인 버튼 수정 
    탭이동 후 팝업 올리기
    */
    return (
        <>
            {productdetailPop === true && detaildata?.idx && <PopProductLeftDetail
                row={detaildata} setproductdetailflag={setproductdetailPop}
                productIdx={detaildata?.idx}
            />}
            <div className='ProductDetailArea'>
                <div>
                    <div className='ProductDetailAreaBG'
                    // onClick={() => {
                    //     setproducttogethersendflag(false);
                    // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop">
                        <div className="ProductpopTitle padding40" style={{ borderBottom: '4px solid #eee', alignItems: 'center', justifyContent: 'center' }}>
                            <span>공동중개 요청이 도착했습니다.</span>
                        </div>
                        <div className="ProductSendInfos padding32" style={{ borderBottom: '4px solid #eee' }}>
                            <div className="fontsize16 bolds">공동중개 수신</div>
                            <Profiles margintClass={'margint20'} memberinfosData={mediation?.user} />
                            <div className='infos margint20'>
                                {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                    if (row?.sell_type === '매매') {
                                        if (x?.viewernames === '보증금' || x?.viewernames === '월세') {
                                            return;
                                        }
                                    } else {
                                        if (x?.viewernames === '매매가') {
                                            return;
                                        }
                                    }

                                    if ([1, 2].includes(row?.category_1)) {
                                        if (x?.viewernames === '토지면적' || x?.viewernames === '연면적') {
                                            return;
                                        }
                                    }
                                    if ([3].includes(row?.category_1)) {
                                        if (x?.viewernames === '전용면적') {
                                            return;
                                        }
                                    }

                                    if (!x?.viewernames) return;
                                    return (
                                        <div key={i}>
                                            <div style={{ width: 140 }}>{x?.viewernames}</div>
                                            <div>{x?.values}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="ProductSendInfos padding32" >
                            {/* <div className="fontsize16 bolds" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <span className="fontsize16 bolds">매칭된 내 고객</span>
                                <span><span className="fontsize16 bolds">2</span>건</span>
                            </div> */}
                            {mediation?.type * 1 === 2 ?
                                <div className="matchinglist">
                                    <div>
                                        <div className="productnumberinfos">
                                            <div className='linedotTxt'>
                                                <span>고객번호 : {customer?.idx}</span>
                                                <span></span>
                                                <span>등록: {moment(customer?.create_dt).format('YY.MM.DD')}</span>
                                            </div>
                                        </div>
                                        <div className="productinfos1">
                                            <div className='linedotTxt'>
                                                <span>{category_2_setting?.find(item => item?.values * 1 === row?.category_2 * 1)?.names}</span>
                                                <span></span>
                                                <span>{customer?.sell_type}</span>
                                            </div>
                                        </div>
                                        <div className="productinfos1 styles2" >{customer?.title}</div>
                                        {customer?.sell_type === '월세' ?
                                            <div className="productinfos1 styles1 bolds" >월세 {numFormat(customer?.price_all_min)}~{numFormat(customer?.price_all_max)}/{numFormat(customer?.price_month_min)}~{numFormat(customer?.price_month_max)}</div>
                                            :
                                            <div className="productinfos1 styles1 bolds" >{numFormat(customer?.price_all_min)}만원 ~ {numFormat(customer?.price_all_max)}만원</div>
                                        }
                                        {/* <div className="productinfos1 styles3" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z" fill="#999999"/>
                                        </svg>                                            
                                        {customer?.citys?.filter(item => item?.polygon === null)?.map(item => item.dong === '전체' ? item.sigungu+" 전체" : item.dong)?.join(", ")}
                                        {customer?.citys?.filter(item => item?.polygon !== null)?.map((item, index) => (index === 0 && customer?.citys?.filter(item => item?.polygon === null)?.length > 0) ? ", 폴리곤"+(index+1) : "폴리곤"+(index+1) )?.join(", ")}
                                    </div> */}
                                    </div>
                                </div>
                                :
                                <div className="matchinglist">
                                    <div>
                                        <div className="productnumberinfos">
                                            <div className='linedotTxt'>
                                                <span>매물번호 : {row?.idx}</span>
                                                <span></span>
                                                <span>등록: {moment(row?.create_dt).format('YY.MM.DD')}</span>
                                            </div>
                                        </div>
                                        <div className="productinfos1">
                                            <div className='linedotTxt'>
                                                <span>{category_2_setting?.find(item => item?.values * 1 === row?.category_2 * 1)?.names}</span>
                                                <span></span>
                                                <span>{row?.sell_type}</span>
                                            </div>
                                        </div>

                                        {row?.sell_type === '월세' ?
                                            <div className="productinfos1 styles1 bolds" >월세 {numFormat(row?.price_all)}/{numFormat(row?.price_month)}</div>
                                            :
                                            <>
                                                {row?.sell_type === '전세' ?
                                                    <div className="productinfos1 styles1 bolds" >{numFormat(row?.price_all)}만원</div>
                                                    :
                                                    <div className="productinfos1 styles1 bolds" >{numFormat(row?.price_sell)}만원</div>
                                                }
                                            </>
                                        }

                                        {/* <div className="productinfos1 styles3" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z" fill="#999999"/>
                                        </svg>                                            
                                        {customer?.citys?.filter(item => item?.polygon === null)?.map(item => item.dong === '전체' ? item.sigungu+" 전체" : item.dong)?.join(", ")}
                                        {customer?.citys?.filter(item => item?.polygon !== null)?.map((item, index) => (index === 0 && customer?.citys?.filter(item => item?.polygon === null)?.length > 0) ? ", 폴리곤"+(index+1) : "폴리곤"+(index+1) )?.join(", ")}
                                    </div> */}
                                    </div>
                                </div>
                            }

                        </div>
                        <div className="ProductSendInfos padding32" >
                            <div
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                }}
                            >
                                <div style={{ width: 120 }}>
                                    <Button
                                        buttonTxt={'닫기'}
                                        disabled={true}
                                        onPress={() => {
                                            setproducttogethersendflag(false);
                                        }}
                                    />
                                </div>
                                <div style={{ width: 'calc(100% - 120px)' }}>
                                    <Button
                                        buttonTxt={mediation?.type * 1 === 2 ? '고객확인' : '매물확인'}
                                        onPress={() => {
                                            setbellshowflag(false);
                                            setproducttogethersendflag(false);
                                            // setdetaildata(row);
                                            // setproductdetailPop(true);     
                                            if (mediation?.type * 1 === 2) {
                                                navigate("/Customer", { state: { customerpopIdx: customer?.idx } });
                                            } else {
                                                navigate("/Product", { state: { itemIdx: row?.idx } });
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <div className="ProductSendInfos padding32" >
                            <div className="fontsize16 bolds">확인사항</div>
                            <div className="bolds margint20">※ 공동중개 요청/수락 전 받드시 읽어주세요.</div>
                            <div className="checkComment">
                                {checkcommentArr?.length > 0 && checkcommentArr?.map((x, i) => {
                                    return (
                                        <div key={i}>
                                            <div>{x?.numbers}</div>
                                            <div>{x?.comment}</div>
                                        </div>                                        
                                    );
                                })}
                            </div>
                            <div className='margint20'>
                                <Checkbox
                                    linetype={'checkimg'}
                                    values={checkvalues}
                                    setvalues={(e) => {
                                        setcheckvalues(e);
                                        seterrormsg('');
                                    }}
                                    namevalue={[
                                        {names: '매물을 공동 요청에 동의함.', values: 0},
                                    ]}
                                    fontweights={400}
                                    fontSizes={12}
                                    sizes={20}
                                />                                
                            </div>        
                            {errormsg &&
                                <p className="input_error margint10" style={{ width: '100%', }}>
                                    <span></span>{errormsg}
                                </p>
                            }    
                            <div 
                                className='margint20'
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                }}
                            >
                                <div style={{ width: 120 }}>
                                    <Button
                                        buttonTxt={'닫기'}
                                        disabled={true} 
                                        onPress={() => { 
                                            setproducttogethersendflag(false);                                    
                                        }}
                                    />                                       
                                </div>
                                <div style={{ width: 120 }}>
                                    <Button
                                        buttonTxt={'거부'}
                                        disabled={true} 
                                        onPress={() => { 
                                            dispatch(
                                                open({
                                                    component: '공동중개 요청을 거부하시겠습니까?',
                                                    button: "거부",
                                                    buttonCencle: "닫기",       
                                                    title: '알림',
                                                    titleviewer: true,          
                                                    alert: false,
                                                    onPress: () => {
                                                        let sender = { idx: mediation?.idx, agree: false }
                                                        dispatch(loadingflas({ loading: true }));
                                                        APIS.postData('/v1/mediation/agree', sender).then(({ data }) => {
                                                            if(data){
                                                                setproducttogethersendflag(false);
                                                                dispatch(close());
                                                                dispatch(listupdater({ listupdate: true }));
                                                            }
                                                        }).catch(({ response }) => {
                                                            const { data } = response;
                                                            dispatch(close());
                                                            seterrormsg(data?.msg);
                                                            return;
                                                        }).finally(() => {
                                                            dispatch(loadingflas({ loading: false }));
                                                        });   
                                                    },
                                                    onCancelPress: () => {
                                                        dispatch(close());
                                                    },
                                                })
                                            );                                        
                                        }}
                                    />                                       
                                </div>
                                <div style={{ width: 'calc(100% - 120px)'}}>
                                    <Button
                                        buttonTxt={'수락하기'}
                                        styles={{ 
                                        }} 
                                        onPress={() => { 
                                            if(checkvalues?.length === 0){
                                                seterrormsg('공동 요청에 동의해주세요.');
                                                return;
                                            }

                                            const PopComponents = () => {
                                                return (
                                                    <div className='producttogetheralertArea2'>
                                                        <div>
                                                            모두의 매물은 거래 가능한 매물·고객을 매칭시키고자 최선을 다하고 있으나, 
                                                            실시간 거래 여부 확인이 물리적으로 어려운 상황입니다.<br />
                                                            가급적이면 공동 중개 수락 전 상대방에게 거래 가능 여부를 확인하시기 바랍니다.<br /><br />

                                                            공동중개 수락 시 <b style={{ color: '#6164A5'}}>고객 상세정보 내 매칭 목록에서 확인</b>할 수 있으며, 상세정보 확인 후 매물을 전송할 수 있습니다. <br /><br />

                                                            * <b>매물 전송은 고객측 부동산에 선택권</b>이 있으며, 매물측 부동산 연락처는 고객에게 제공되지 않습니다.<br />
                                                            * 고객측 부동산은 제공받은 매물에 대해서 <b>반드시 매물측 부동산과 소통</b>하시기 바랍니다. <b>상도에 어긋나는 비매너 행위는 평가점수 하락 및 서비스 이용에 제재가 될 수 있습니다.</b>


                                                        </div>
                                                        <div style={{ width: '100%', textAlign: 'center', gap: 8, display: 'flex', flexDirection: 'column' }}>
                                                            <p className='fontsize20 bolds'>{mediation?.user?.name} {mediation?.user?.rank}</p>
                                                            <p className='fontsize16 bolds'>{hpHypen(mediation?.user?.hp || '')}</p>
                                                            <p className='color666'>{mediation?.user?.compony?.title}</p>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            dispatch(
                                                open({
                                                    component: <PopComponents />,
                                                    button: "수락하기",
                                                    buttonCencle: "닫기",
                                                    titleviewer: false,          
                                                    alert: false,
                                                    onCancelPress: () => {
                                                        dispatch(close());
                                                    },                                                    
                                                    onPress: () => {
                                                        dispatch(close());

                                                        let sender = { idx: mediation?.idx, agree: true }
                                                        dispatch(loadingflas({ loading: true }));
                                                        APIS.postData('/v1/mediation/agree', sender).then(({ data }) => {
                                                            if(data){
                                                                dispatch(listupdater({ listupdate: true }));
                                                                const PopComponents2 = () => {
                                                                    return (
                                                                        <div className='producttogetheralertArea'>
                                                                            <div>공동중개 요청(수락)이 완료 되었습니다.</div>
                                                                            <div>공동중개 평가로 인한 불이익이 없도록 상도덕에 따른 매너있는 협업 부탁드립니다.</div>
                                                                            <div>
                                                                            공동중개 후기 작성은 계약이 체결되거나 공동중개가 종료된 이후 작성할 수 있습니다. (1회만 작성 가능)
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                                dispatch(
                                                                    open({
                                                                        component: <PopComponents2 />,
                                                                        button: "닫기",
                                                                        titleviewer: false,          
                                                                        alert: false,
                                                                        onPress: () => {
                                                                            setproducttogethersendflag(false);
                                                                            dispatch(close());
                                                                        },
                                                                    })
                                                                );  

                                                            }
                                                        }).catch(({ response }) => {
                                                            const { data } = response;
                                                            //console.log(data);
                                                            seterrormsg(data?.msg);
                                                            return;
                                                        }).finally(() => {
                                                            dispatch(loadingflas({ loading: false }));
                                                        });  
                                                                                                                
                                                    },
                                                })
                                            );                                        
                                        }}
                                    />     
                                </div>                            
                            </div>                                              
                        </div> */}

                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )
}